var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLyrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00001 1.1C3.95066 1.1 3.10001 1.95066 3.10001 3V21C3.10001 22.0494 3.95067 22.9 5.00001 22.9H19C20.0494 22.9 20.9 22.0494 20.9 21V6.1H20.8262L15.9 1.17382V1.1H5.00001ZM15.9 3.71941V6.1H18.2806L15.9 3.71941ZM4.90001 3C4.90001 2.94477 4.94478 2.9 5.00001 2.9H14.1V7.9H19.1V21C19.1 21.0552 19.0552 21.1 19 21.1H5.00001C4.94477 21.1 4.90001 21.0552 4.90001 21V3ZM7.60001 15.1H16.4V16.9H7.60001V15.1ZM16.4 11.1H7.60001V12.9H16.4V11.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyrics);
export default __webpack_public_path__ + "static/media/lyrics.9c67249a9241d2112d77af1652708848.svg";
export { ForwardRef as ReactComponent };